export const getSubdomains = () => {
  const host = window.location.host;
  const subdomains = host
    .split(".")
    .slice(0, host.includes("localhost") ? -1 : -2);

  return subdomains;
}